'use client';

import { QueryClient } from '@tanstack/react-query';
import { getCookie } from 'cookies-next';
import { GraphQLClient } from 'graphql-request';

const IS_SERVER = typeof window === 'undefined';
const API_URL = IS_SERVER ? process.env.API_URI : process.env.NEXT_PUBLIC_API_URI;
// const WS_URL = IS_SERVER ? process.env.WS_URI : process.env.NEXT_PUBLIC_WS_URI;

const token = getCookie(process.env.NEXT_PUBLIC_USER_AUTH_TOKEN_NAME!);
const graphqlClient = new GraphQLClient(API_URL || 'http://localhost:3333/graphql', {
  headers: {
    authorization: token ? `Bearer ${token}` : '',
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: false,
    },
  },
});

export { queryClient, graphqlClient };
